import { type RouteConfig } from 'vue-router'
import { ACTIVITY_LOCATION_PAGE } from './constants'
import Home from '@/pages/home.vue'
import RedeemCode from '@/pages/redeemCode.vue'
import Active from '@/pages/active.vue'
import NotFound from '@/pages/404.vue'

const routes: Array<RouteConfig> = [
  { path: '/', name: 'home', component: Home, meta: { title: 'UniReel', activityIndex: ACTIVITY_LOCATION_PAGE.INDEX }, props: true },
  { path: '/share', name: 'home', component: Home, meta: { title: 'UniReel', activityIndex: ACTIVITY_LOCATION_PAGE.INDEX }, props: true },
  { path: '/promot/welcia1215', name: 'redeemCode', component: RedeemCode, meta: { title: 'UniReel' }, props: true },
  { path: '/active', name: 'active', component: Active, meta: { title: 'UniReel' }, props: true },
  { path: '*', name: 'notFound', alias: '/404', component: NotFound, meta: { title: '404', requiresAuth: false } },
]

export default routes
